import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Pagination, notification } from 'antd';
import { Exportacao } from '~/components';
import { UltimaAtualizacao } from './UltimaAtualizacao.component';
import { fileManagerPaiDownload } from '~/services/FileManager/file-manager.service';
import { Container, NumberRegistersArea, ButtonsArea } from './Footer.styled';
import { exportarVisao } from '../../services/moduloVisao.service';
import { getUrlComDominio } from '~/modules/Helper/getUrl-helper';
import { AA_DISABLED_BORDER } from '~/modules/Helper/contrast.helper';
import { QUANTIDADE_REGISTROS_OPCOES } from '~/modules/Helper/numeroQuantidadeRegistros';

function Footer({
  moduloVisao,
  quantidadeRegistros,
  setQuantidadeRegistros,
  page,
  setPage,
  configuracao,
  modulo,
  visao,
  filtroExportacao,
  filtroOrdenacaoExportacao,
  periodicidade,
  periodo,
  exercicio,
  colunaFiltroRedirecionaVisao,
  valorFiltroRedirecionaVisao,
  tipoValorFiltroRedirecionaVisao,
  dataUltimaAtualizacao,
}) {
  const [tipo, setTipo] = useState(null);

  const configuration = useSelector(state => state.configuration);
  const { corFundoTituloGrid, corTituloGrid } = configuration;

  function setNewTipo() {
    if (configuracao.Tipo !== tipo) {
      setTipo(configuracao.Tipo);
    }
  }

  useEffect(() => {
    setTipo(configuracao.Tipo);
    setNewTipo();
  }, [configuracao.Tipo, setNewTipo]);

  function exportar(tipoExportacao) {
    if (tipoExportacao === 'uri') {
      navigator.clipboard.writeText(window.location.href);
      notification.success({
        message: 'URI Copiada com Sucesso!',
      });
    } else {
      const FiltroRedirecionaVisao = {
        Campo: colunaFiltroRedirecionaVisao,
        Valor: valorFiltroRedirecionaVisao,
        TipoValor: tipoValorFiltroRedirecionaVisao,
      };

      const dtoExportacao = {
        ChaveModulo: modulo,
        NomeVisao: visao,
        Filtros: filtroExportacao,
        Periodicidade: periodicidade,
        Periodo: periodo,
        Exercicio: exercicio,
        Ordenacao: filtroOrdenacaoExportacao,
        Pagina: page,
        QuantidadeRegistros: quantidadeRegistros,
        FiltroRedirecionaVisao,
        UrlExportacao: getUrlComDominio(),
      };

      exportarVisao(tipoExportacao, dtoExportacao).then(res => {
        fileManagerPaiDownload(res.data);
      });
    }
  }

  return (
    <Container>
      <NumberRegistersArea
        corFundoTituloGrid={corFundoTituloGrid}
        corTituloGrid="#000"
      >
        <Pagination
          current={page}
          showSizeChanger={false}
          pageSize={quantidadeRegistros}
          total={moduloVisao.QuantidadeRegistros}
          showTotal={total => {
            return (
              <p style={{ color: corTituloGrid, textAlign: 'center' }}>
                <strong>Total: </strong>
                {`${new Intl.NumberFormat('pt-BR').format(total)} registros`}
              </p>
            );
          }}
          onChange={pag => setPage(pag)}
        />

        <label
          htmlFor="grid-qtd-registros"
          style={{
            color: corTituloGrid,
            fontWeight: 600,
            fontSize: 13,
            marginRight: 8,
          }}
        >
          Registros por página
        </label>
        <select
          id="grid-qtd-registros"
          value={String(quantidadeRegistros)}
          onChange={event => {
            setPage(1);
            setQuantidadeRegistros(Number(event.target.value));
          }}
          style={{
            color: '#000',
            minHeight: 32,
            borderRadius: 2,
            border: `1px solid ${AA_DISABLED_BORDER}`,
            padding: '4px 8px',
            background: '#fff',
          }}
        >
          {QUANTIDADE_REGISTROS_OPCOES.map(quantidade => (
            <option key={quantidade} value={String(quantidade)}>
              {quantidade} registros
            </option>
          ))}
        </select>
      </NumberRegistersArea>

      <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
        {dataUltimaAtualizacao && (
          <UltimaAtualizacao
            dataHora={dataUltimaAtualizacao}
            corTituloGrid={corTituloGrid}
          />
        )}
      </div>

      <ButtonsArea corTituloGrid={corTituloGrid}>
        {moduloVisao != null && moduloVisao.Valores.length !== 0 && (
          <Exportacao
            onClick={exportar}
            QuantidadeRegistros={moduloVisao.QuantidadeRegistros}
          />
        )}
      </ButtonsArea>
    </Container>
  );
}

export default Footer;
